import React from "react";
import { Route, IndexRoute } from "react-router";

import App from "./components/ui/App";
import Dashboard from "./components/views/Dashboard";
import Admin from "./components/views/Admin";
import Search from "./components/views/Search";
import Favorites from "./components/views/Favorites";
import Records from "./components/views/Records";
import IoProducts from "./components/views/IoProducts";
import Campaigns from "./components/views/Campaigns";
import LineItems from "./components/views/LineItems";
import SingleRecord from "./components/views/SingleRecord";
import CreateRecord from "./components/views/CreateRecord";
import SingleUserView from "./components/views/SingleUserView";
import SingleUserEdit from "./components/views/SingleUserEdit";
import Login from "./components/views/Login";
import ResetPassword from "./components/views/ResetPassword";
import Setup from "./components/views/Setup";
import Logout from "./components/views/Logout";
import PowerBI from "./components/views/PowerBI";
import FileDrawer from "./components/views/FileDrawer";
import TimeTracking from "./components/views/TimeTracking";
import TimeReport from "./components/views/TimeReport";
import TimeListView from "./components/views/TimeListView";
import AdminFields from "./components/admin/AdminFields";
import AdminFieldsContext from "./components/admin/AdminFieldsContext";
import AdminUsers from "./components/admin/AdminUsers";
import NotFoundPage from "./components/views/NotFoundPage";
import AccessDenied from "./components/views/AccessDenied";

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Dashboard} />
    <Route path="login" component={Login} />
    <Route path="logout" component={Logout} />
    <Route path="login/reset" component={ResetPassword} />

    <Route path="search" component={Search} />
    <Route path="search/*" component={Search} />

    <Route path="user/favorites" component={Favorites} />
    <Route path="user/favorites/*" component={Favorites} />

    <Route
      path="clients"
      component={Records}
      type="client"
      niceName="Clients"
    />
    <Route
      path="client/view/*"
      component={SingleRecord}
      mode="view"
      type="client"
      niceName="Client"
    />
    <Route
      path="client/history/*"
      component={SingleRecord}
      mode="history"
      type="client"
      niceName="Client"
    />
    <Route
      path="client/edit/*"
      component={SingleRecord}
      mode="edit"
      type="client"
      niceName="Client"
    />
    <Route
      path="client/create"
      component={CreateRecord}
      type="client"
      niceName="Client"
    />

    <Route path="rfps" component={Records} type="rfp" niceName="RFPs" />
    <Route
      path="rfp/view/*"
      component={SingleRecord}
      mode="view"
      type="rfp"
      niceName="RFP"
    />
    <Route
      path="rfp/history/*"
      component={SingleRecord}
      mode="history"
      type="rfp"
      niceName="RFP"
    />
    <Route
      path="rfp/edit/*"
      component={SingleRecord}
      mode="edit"
      type="rfp"
      niceName="RFP"
    />
    <Route
      path="rfp/create"
      component={CreateRecord}
      type="rfp"
      niceName="RFP"
    />

    <Route path="ios" component={Records} type="io" niceName="IOs" />
    <Route
      path="io/view/*"
      component={SingleRecord}
      mode="view"
      type="io"
      niceName="IO"
    />
    <Route
      path="io/history/*"
      component={SingleRecord}
      mode="history"
      type="io"
      niceName="IO"
    />
    <Route
      path="io/edit/*"
      component={SingleRecord}
      mode="edit"
      type="io"
      niceName="IO"
    />
    <Route path="io/create" component={CreateRecord} type="io" niceName="IO" />

    <Route
      path="io-products"
      component={IoProducts}
      type="io"
      niceName="IO Products"
    />
    <Route
      path="line-items"
      component={LineItems}
      type="rfp"
      niceName="Line Items"
    />
     <Route
      path="campaigns"
      component={Campaigns}
      type="campaign"
      niceName="Campaigns"
    />

    <Route
      path="user/view/*"
      component={SingleUserView}
      mode="view"
      type="user"
      niceName="User"
    />
    <Route
      path="user/edit/*"
      component={SingleUserEdit}
      mode="edit"
      type="user"
      niceName="User"
    />
    <Route
      path="user/setup/*"
      component={Setup}
      mode="setup"
      type="user"
      niceName="User"
    />
    <Route
      path="user/reset/*"
      component={Setup}
      mode="reset"
      type="user"
      niceName="User"
    />
    <Route
      path="user/create"
      component={SingleUserEdit}
      mode="create"
      type="user"
      niceName="User"
    />

    <Route
      path="admin"
      component={Admin}
      mode="admin"
      type="admin"
      niceName="Administration"
    />
    <Route
      path="admin/users"
      component={AdminUsers}
      mode="admin"
      type="user"
      niceName="Users"
    />
    <Route
      path="admin/fields"
      component={AdminFields}
      mode="admin"
      type="field"
      niceName="Fields"
    />
    <Route
      path="admin/fields/*"
      component={AdminFieldsContext}
      mode="admin"
      type="field"
      niceName="Fields"
    />

    <Route path="files" component={FileDrawer} />
    <Route path="ships-log" component={PowerBI} />

    <Route path="time" component={TimeTracking} />
    <Route path="time/date/:date" component={TimeTracking} />
    <Route path="time/date/:date/add" component={TimeTracking} adding={true} />
    <Route
      path="time/date/:date/add/timer"
      component={TimeTracking}
      adding={true}
      fromTimer={true}
    />
    <Route
      path="time/date/:date/add/previous"
      component={TimeTracking}
      adding={true}
      fromPrevious={true}
    />
    <Route path="time/reports" component={TimeReport} />
    <Route path="time/entries" component={TimeListView} />

    <Route path="access-denied" component={AccessDenied} />
    <Route path="*" component={NotFoundPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js